import "core-js/modules/web.dom-collections.iterator.js";
import { versionedComponent } from "@edreamsodigeo/frontend-core";
export const AB_ALIAS = {
  XSELL_MKT_CAMPAIGN: "BAIT_BAIT24",
  HSA_PRIME_ACQUISITION_BANNER: "BASF_BASF2267",
  TRIPDETAILS_AUTOREFRESH_ITERATION: "FSC_SUMO4619",
  BIM_TRIPDETAILS_NOTIFICATIONS_TO_OF2: "FSC_SUMO4809",
  BIM_SUPPORT_AREA_NOTIFICATIONS_TO_OF2: "FSC_SUMO5053",
  IMPLEMENT_REEBOK_FOR_KO: "FSC_SUMO5262",
  CANCELLATION_FLOW: "BASF_BASF647",
  RYANAIR_CONTACTS: "FSC_SUMO5359",
  ACCOMMODATION_CARD_DETAILS: "DPT_DPT5984",
  ALTERNATIVES_FLOW_OF2: "CAT_CAT2840",
  UPCOMING_NOT_LOGGED: "FSC_SUMO5309",
  MULTIPLE_VIRTUAL_CREDENTIALS: "FSC_SUMO5474",
  SPLIT_MMB_FROM_TRIPDETAILS: "FSC_SUMO5647",
  HSA_CONGRATULATIONS_MODAL: "BASF_BASF2530",
  TRAIN_REVAMP: "FSC_SUMO5697"
};
export const AB_PARTITIONS = {
  A: 1,
  B: 2,
  C: 3,
  D: 4
};
export const AB_PARTITIONS_VALUES = Object.values(AB_PARTITIONS);
export const AB_PARTITIONS_LABELS = Object.entries(AB_PARTITIONS).reduce((acc, [key, value]) => {
  acc[value] = key;
  return acc;
}, {});
export const aliases = Object.values(AB_ALIAS);
export const createXSELL_MKT_CAMPAIGNVersion = versionedComponent(AB_ALIAS.XSELL_MKT_CAMPAIGN);
export const createHsaPrimeAcquisitionBannerABVersion = versionedComponent(AB_ALIAS.HSA_PRIME_ACQUISITION_BANNER);
export const createTRIPDETAILS_AUTOREFRESH_ITERATIONVersion = versionedComponent(AB_ALIAS.TRIPDETAILS_AUTOREFRESH_ITERATION);
export const createBIM_TRIPDETAILS_NOTIFICATIONS_TO_OF2 = versionedComponent(AB_ALIAS.BIM_TRIPDETAILS_NOTIFICATIONS_TO_OF2);
export const createBIM_SUPPORT_AREA_NOTIFICATIONS_TO_OF2 = versionedComponent(AB_ALIAS.BIM_SUPPORT_AREA_NOTIFICATIONS_TO_OF2);
export const createIMPLEMENT_REEBOK_FOR_KO = versionedComponent(AB_ALIAS.IMPLEMENT_REEBOK_FOR_KO);
export const createCANCELLATION_FLOW = versionedComponent(AB_ALIAS.CANCELLATION_FLOW);
export const createRYANAIR_CONTACTS = versionedComponent(AB_ALIAS.RYANAIR_CONTACTS);
export const createACCOMMODATION_CARD_DETAILS = versionedComponent(AB_ALIAS.ACCOMMODATION_CARD_DETAILS);
export const createALTERNATIVES_FLOW_OF2 = versionedComponent(AB_ALIAS.ALTERNATIVES_FLOW_OF2);
export const createUPCOMING_NOT_LOGGED = versionedComponent(AB_ALIAS.UPCOMING_NOT_LOGGED);
export const createMULTIPLE_VIRTUAL_CREDENTIALS = versionedComponent(AB_ALIAS.MULTIPLE_VIRTUAL_CREDENTIALS);
export const createSPLIT_MMB_FROM_TRIPDETAILS = versionedComponent(AB_ALIAS.SPLIT_MMB_FROM_TRIPDETAILS);
export const createHSA_CONGRATULATIONS_MODAL = versionedComponent(AB_ALIAS.HSA_CONGRATULATIONS_MODAL);
export const createTRAIN_REVAMP = versionedComponent(AB_ALIAS.TRAIN_REVAMP);